module.exports = __webpack_public_path__ + "static/img/dianwei.eeefcd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/dianwei.png
// module id = G+pf
// module chunks = 0